/**
 * Utilitários JavaScript do template NiceShop para Vue
 * Funções que podem ser importadas e usadas nos componentes Vue
 */

// Função para inicializar AOS (Animate On Scroll)
export function initAOS() {
  if (typeof AOS !== 'undefined') {
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    })
  }
}

// Função para inicializar GLightbox
export function initGLightbox() {
  if (typeof GLightbox !== 'undefined') {
    return GLightbox({
      selector: '.glightbox'
    })
  }
}

// Função para inicializar PureCounter
export function initPureCounter() {
  if (typeof PureCounter !== 'undefined') {
    new PureCounter()
  }
}

// Função para inicializar Swiper
export function initSwiper() {
  if (typeof Swiper !== 'undefined') {
    const swiperElements = document.querySelectorAll(".init-swiper")
    swiperElements.forEach(function(swiperElement) {
      const configElement = swiperElement.querySelector(".swiper-config")
      if (configElement) {
        let config = JSON.parse(configElement.innerHTML.trim())
        new Swiper(swiperElement, config)
      }
    })
  }
}

// Função para inicializar Drift (zoom de imagens)
export function initDrift() {
  if (typeof Drift !== 'undefined') {
    const driftOptions = {
      paneContainer: document.querySelector('.image-zoom-container'),
      inlinePane: window.innerWidth < 768 ? true : false,
      inlineOffsetY: -85,
      containInline: true,
      hoverBoundingBox: false,
      zoomFactor: 3,
      handleTouch: false
    }

    const mainImage = document.getElementById('main-product-image')
    if (mainImage) {
      new Drift(mainImage, driftOptions)
    }
  }
}

// Função para toggle do menu mobile
export function initMobileNav() {
  const mobileNavToggleBtn = document.querySelector('.mobile-nav-toggle')
  
  if (mobileNavToggleBtn) {
    function mobileNavToogle() {
      document.querySelector('body').classList.toggle('mobile-nav-active')
      mobileNavToggleBtn.classList.toggle('bi-list')
      mobileNavToggleBtn.classList.toggle('bi-x')
    }
    
    mobileNavToggleBtn.addEventListener('click', mobileNavToogle)
    
    // Hide mobile nav on same-page/hash links
    document.querySelectorAll('#navmenu a').forEach(navmenu => {
      navmenu.addEventListener('click', () => {
        if (document.querySelector('.mobile-nav-active')) {
          mobileNavToogle()
        }
      })
    })
  }
}

// Função para scroll top button
export function initScrollTop() {
  let scrollTop = document.querySelector('.scroll-top')
  
  if (scrollTop) {
    function toggleScrollTop() {
      window.scrollY > 100 ? scrollTop.classList.add('active') : scrollTop.classList.remove('active')
    }
    
    scrollTop.addEventListener('click', (e) => {
      e.preventDefault()
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    })
    
    window.addEventListener('load', toggleScrollTop)
    document.addEventListener('scroll', toggleScrollTop)
  }
}

// Função para toggle de dropdowns mobile
export function initMobileDropdowns() {
  document.querySelectorAll('.navmenu .toggle-dropdown').forEach(navmenu => {
    navmenu.addEventListener('click', function(e) {
      e.preventDefault()
      this.parentNode.classList.toggle('active')
      this.parentNode.nextElementSibling.classList.toggle('dropdown-active')
      e.stopImmediatePropagation()
    })
  })
}

// Função para FAQ toggle
export function initFAQ() {
  document.querySelectorAll('.faq-item h3, .faq-item .faq-toggle, .faq-item .faq-header').forEach((faqItem) => {
    faqItem.addEventListener('click', () => {
      faqItem.parentNode.classList.toggle('faq-active')
    })
  })
}

// Função para inicializar todas as funcionalidades
export function initAllTemplateScripts() {
  initAOS()
  initGLightbox()
  initPureCounter()
  initSwiper()
  initDrift()
  initMobileNav()
  initScrollTop()
  initMobileDropdowns()
  initFAQ()
}

// Função para aplicar classe scrolled no scroll
export function initScrollClass() {
  function toggleScrolled() {
    const selectBody = document.querySelector('body')
    const selectHeader = document.querySelector('#header')
    if (!selectHeader || !selectHeader.classList.contains('scroll-up-sticky') && !selectHeader.classList.contains('sticky-top') && !selectHeader.classList.contains('fixed-top')) return
    window.scrollY > 100 ? selectBody.classList.add('scrolled') : selectBody.classList.remove('scrolled')
  }

  document.addEventListener('scroll', toggleScrolled)
  window.addEventListener('load', toggleScrolled)
}

// Função para preloader
export function initPreloader() {
  const preloader = document.querySelector('#preloader')
  if (preloader) {
    window.addEventListener('load', () => {
      preloader.remove()
    })
  }
}

// Função para countdown timer
export function initCountdown() {
  function updateCountDown(countDownItem) {
    const timeleft = new Date(countDownItem.getAttribute('data-count')).getTime() - new Date().getTime()

    const days = Math.floor(timeleft / (1000 * 60 * 60 * 24))
    const hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((timeleft % (1000 * 60)) / 1000)

    const daysElement = countDownItem.querySelector('.count-days')
    const hoursElement = countDownItem.querySelector('.count-hours')
    const minutesElement = countDownItem.querySelector('.count-minutes')
    const secondsElement = countDownItem.querySelector('.count-seconds')

    if (daysElement) daysElement.innerHTML = days
    if (hoursElement) hoursElement.innerHTML = hours
    if (minutesElement) minutesElement.innerHTML = minutes
    if (secondsElement) secondsElement.innerHTML = seconds
  }

  document.querySelectorAll('.countdown').forEach(function(countDownItem) {
    updateCountDown(countDownItem)
    setInterval(function() {
      updateCountDown(countDownItem)
    }, 1000)
  })
}
